import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MatAutocompleteModule, MatInputModule } from '@angular/material';
import { AddressAutocompleteComponent } from './address-autocomplete/address-autocomplete.component';

@NgModule({
  declarations: [AddressAutocompleteComponent],
  exports: [
    AddressAutocompleteComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    MatAutocompleteModule,
    MatInputModule,
  ]
})
export class FormsComponentsModule { }
